import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

import { logSearchResultsPresented, logWidgetEmptySearchResults } from './bi';
import { TRootState } from './common/reducers';
import { loadSolutions } from './common/thunks/solutions.thunk';

export const biMiddleware = ({ getState }: MiddlewareAPI<any, TRootState>) => (
  next: Dispatch,
) => (action: AnyAction) => {
  if (loadSolutions.fulfilled.match(action)) {
    const state = getState();

    logSearchResultsPresented(state, action.payload);
    if (state.solutions.isUserTypedSearch && action.payload.length === 0) {
      logWidgetEmptySearchResults(state);
    }
  }

  return next(action);
};
